import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function ArrowFullDown(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("g", {
    clipPath: "url(#arrow-full-down)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.852 14.0308C16.1423 13.7324 16.1358 13.2552 15.8374 12.9649C15.539 12.6746 15.0618 12.6812 14.7715 12.9796L10.5909 17.2766L10.5909 0.753893C10.5909 0.337597 10.2534 0.000121753 9.83711 0.000121771C9.42081 0.00012179 9.08334 0.337597 9.08334 0.753893L9.08334 17.5826L4.27613 12.9618C3.97601 12.6733 3.49884 12.6827 3.21035 12.9828C2.92185 13.283 2.93129 13.7601 3.23141 14.0486L9.20396 19.7897C9.50281 20.0769 9.97753 20.069 10.2666 19.7719L15.852 14.0308Z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "arrow-full-down"
  }, React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))));
}

export { ArrowFullDown };
//# sourceMappingURL=ArrowFullDown.js.map